import { useState } from 'react'
import type { TaskQueueItem } from '../../lib/tasks'
import { useAuthSession } from '../../lib/authSession'
import TaskPane from '../TaskPane'
import { useRead } from '../navigation/useRead'
import { ErrorState, Skeleton } from '../state'

/** Fetch the current task; the subchain summary never supplies action payloads. */
export default function ContextTaskPane({
  taskId,
  onResolved,
}: {
  taskId: string
  onResolved: () => void
}) {
  const [refresh, setRefresh] = useState(0)
  const session = useAuthSession()
  const task = useRead<TaskQueueItem>(`/api/tasks/${encodeURIComponent(taskId)}`, refresh)
  if (task.loading) return <Skeleton kind="cards" n={1} height={260} />
  if (task.error)
    return (
      <ErrorState what="current task" error={task.error} onRetry={() => setRefresh((n) => n + 1)} />
    )
  if (!task.value || task.value.task_id !== taskId) return null
  if (task.value.status !== 'open')
    return (
      <div role="status">
        <p>This item is no longer open.</p>
        <button type="button" className="vbtn" onClick={onResolved}>
          Refresh open items
        </button>
      </div>
    )
  return (
    <TaskPane
      key={JSON.stringify([taskId, session, refresh])}
      task={task.value}
      rkDecksOn
      onResolved={onResolved}
    />
  )
}
